const schemaGenerator = faqs => {
  const mainEntities = faqs.map(faq => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  }));
  return {
    '@type': 'FAQpage',
    mainEntity: mainEntities,
  };
};

export default schemaGenerator;
